import { render, staticRenderFns } from "./GlobalConfList.vue?vue&type=template&id=5c95349e&scoped=true&"
import script from "./GlobalConfList.vue?vue&type=script&lang=js&"
export * from "./GlobalConfList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c95349e",
  null
  
)

export default component.exports